import { createWithContextAndReduxStateHOC } from 'contexts/support/createWithContextAndReduxStateHOC'
import { createWithContextStateHOC } from 'contexts/support/createWithContextStateHOC'

import OfferPageStateContext from './offerPageStateContext'
import type { OfferPageState } from './offerPageStateReducer'

const withOfferPageState = createWithContextStateHOC<OfferPageState>(OfferPageStateContext, 'withOfferPageState')

export const withOfferPageAndReduxState = createWithContextAndReduxStateHOC<OfferPageState>(OfferPageStateContext, 'withOfferPageAndReduxState')

export default withOfferPageState
